import { RootPaths } from "@src/appV2/App/paths";

export const PAYOUT_SETTINGS_BASE_PATH = "payout-settings";
export const PAYOUT_SETTINGS_FULL_PATH = `${RootPaths.APP_V2_HOME}/${PAYOUT_SETTINGS_BASE_PATH}`;
